import {
    ATTEMPT_UPLOAD_AVATAR,
    UPLOAD_AVATAR_SUCCEEDED,
    UPLOAD_AVATAR_FAILED,
    ATTEMPT_CREATE_ATHLETE,
    CREATE_ATHLETE_SUCCEEDED,
    CREATE_ATHLETE_FAILED,

    CREATE_ATHLETE,
    EDIT_ATHLETE,
    CLOSE_CREATE_ATHLETE,
    CLOSE_EDIT_ATHLETE,
    LOADED_CACHED_ATHLETE,
    FETCH_ATHLETE_SUCCEEDED,
    UPDATE_ATHLETE_FIRST_NAME,
    UPDATE_ATHLETE_MIDDLE_NAME,
    UPDATE_ATHLETE_LAST_NAME,
    UPDATE_ATHLETE_GROUP,
    SAVE_ATHLETE_METADATA_SUCCEEDED,
    REMOVE_ATHLETE_SUCCEEDED,
    SIGN_OUT_SUCCEEDED,
    UPDATE_ATHLETE_EMAIL,
    UPDATE_ATHLETE_TEAM,
} from 'shared_redux/actions';

const createDefaultState = () => ({
    isUploadingAvatar: false,
    isCreating: false,
    isEditing: false,
    isLoadingEmail: false,
    organizationId: null,
    athleteId: null,
    groupId: null,
    selectedTeamId: null,
    firstName: null,
    middleName: null,
    lastName: null,
    email: null,
    inviteStatus: null, // 'none', 'pending', 'accepted'
});

const processAthleteData = (athlete, state) => {
    console.log('Processing athlete data:', athlete);
    console.log('Athlete account_invite:', athlete.account_invite);
    console.log('Athlete group:', athlete.group);
    
    // Get email from account_invite
    const inviteEmail = athlete.account_invite ? athlete.account_invite.email : null;
    console.log('Email from invite:', inviteEmail);
    
    // Get team_id from the athlete's group, with fallback to direct team_id
    const teamId = athlete.group ? athlete.group.team_id : athlete.team_id;
    console.log('Loading team_id from athlete:', teamId);
    
    const updatedState = {
        ...state,
        isLoadingEmail: false,
        firstName: athlete.first_name,
        middleName: athlete.middle_name,
        lastName: athlete.last_name,
        groupId: athlete.group_id,
        selectedTeamId: teamId,
        email: inviteEmail,
        inviteStatus: athlete.account_id ? 'accepted' : (athlete.account_invite_id ? 'pending' : 'none'),
    };
    
    console.log('Processed athlete state:', {
        groupId: updatedState.groupId,
        selectedTeamId: updatedState.selectedTeamId,
        email: updatedState.email,
        inviteStatus: updatedState.inviteStatus
    });
    
    return updatedState;
};

export default (state = createDefaultState(), action) => {
    console.log('Profile reducer action:', action.type, action);

    switch (action.type) {
        case ATTEMPT_UPLOAD_AVATAR:
            return {
                ...state,
                isUploadingAvatar: true,
            };
        case ATTEMPT_CREATE_ATHLETE:
            if (action.file) {
                return {
                    ...state,
                    isUploadingAvatar: true,
                };
            } else {
                return state;
            }
        case UPLOAD_AVATAR_SUCCEEDED:
        case UPLOAD_AVATAR_FAILED:
        case CREATE_ATHLETE_FAILED:
            return {
                ...state,
                isUploadingAvatar: false,
            };
        case CREATE_ATHLETE:
            return {
                ...state,
                isUploadingAvatar: false,
                isCreating: true,
                isEditing: false,
                athleteId: null,
                organizationId: action.organizationId,
                groupId: action.groupId,
                firstName: null,
                middleName: null,
                lastName: null,
            };
        case EDIT_ATHLETE:
            return {
                ...state,
                isUploadingAvatar: false,
                isCreating: false,
                isEditing: true,
                isLoadingEmail: true,
                athleteId: action.athleteId,
                organizationId: null,
                groupId: null,
                selectedTeamId: null,
                firstName: null,
                middleName: null,
                lastName: null,
                email: null,
                inviteStatus: null,
            };
        case LOADED_CACHED_ATHLETE:
            return processAthleteData(action.athlete, state);
        case FETCH_ATHLETE_SUCCEEDED:
            return processAthleteData(action.payload, state);
        case UPDATE_ATHLETE_FIRST_NAME:
            return {
                ...state,
                firstName: action.firstName,
            };
        case UPDATE_ATHLETE_MIDDLE_NAME:
            return {
                ...state,
                middleName: action.middleName,
            };
        case UPDATE_ATHLETE_LAST_NAME:
            return {
                ...state,
                lastName: action.lastName,
            };
        case UPDATE_ATHLETE_TEAM:
            console.log('UPDATE_ATHLETE_TEAM action received with teamId:', action.teamId);
            return {
                ...state,
                selectedTeamId: action.teamId,
            };
        case UPDATE_ATHLETE_GROUP:
            return {
                ...state,
                groupId: action.groupId,
            };
        case UPDATE_ATHLETE_EMAIL:
            return {
                ...state,
                email: action.email,
            };
        case CLOSE_CREATE_ATHLETE:
        case CLOSE_EDIT_ATHLETE:
        case SAVE_ATHLETE_METADATA_SUCCEEDED:
        case CREATE_ATHLETE_SUCCEEDED:
        case REMOVE_ATHLETE_SUCCEEDED:
            return {
                ...state,
                isUploadingAvatar: false,
                isCreating: false,
                isEditing: false,
                athleteId: null,
                organizationId: null,
                groupId: null,
                selectedTeamId: null,
                firstName: null,
                middleName: null,
                lastName: null,
                email: null,
                inviteStatus: null,
            };
        case SIGN_OUT_SUCCEEDED:
            return createDefaultState();
        default:
            return state;
    }
};
